import { useMemo, useState } from 'react';

export default function useCloudProvider() {
  const cloudProvidersList = useMemo(
    () => [
      { id: 1, name: 'Azure' },
      { id: 2, name: 'GCP' }
    ],
    []
  );

  const [selectedCloud, setCloud] = useState(0);

  // console.log(selectedCloud, 'vvvselectedCloud');

  function selectCloud(id: number) {
    setCloud(id);
  }

  return { cloudProvidersList, selectedCloud, selectCloud };
}
